import React from 'react';
import { Grid, Box, Text } from '@cad-arc';
import { DataPrivacy } from '../common/components/datadog-privacy';
import { FrQueueColumnHeaders } from '../common/components/fr-queues/fr-queue-column-headers';
import { WorkspaceQueue } from '../panels/workspace-queue';

export const FrQueueGroupHeader = ({
    title,
    count,
    columnWidths,
    densityCompactOptions,
    groupIndex,
}: {
    title: string;
    count: number;
    columnWidths?: string;
    groupIndex: number;
    densityCompactOptions: {
        isDisplayDensityCompact: boolean;
        isSelfCol: boolean;
        workspaceQueue?: WorkspaceQueue;
        unmaskedColumns?: Set<string>;
    };
}) => {
    return (
        <>
            <Grid
                w="100%"
                style={
                    columnWidths
                        ? {
                              '--columns': columnWidths,
                          }
                        : undefined
                }
            >
                <Box
                    p="8px"
                    pt={groupIndex > 0 ? '16px' : '8px'}
                    w="100%"
                    backgroundColor={
                        densityCompactOptions.isDisplayDensityCompact
                            ? 'surface.foreground'
                            : 'surface.canvas'
                    }
                >
                    <DataPrivacy privacy="unmask">
                        <Text variant="headingMd">
                            {title} ({count})
                        </Text>
                    </DataPrivacy>
                </Box>
                {densityCompactOptions.isDisplayDensityCompact &&
                    !!densityCompactOptions.workspaceQueue && (
                        <FrQueueColumnHeaders
                            workspaceQueue={densityCompactOptions.workspaceQueue}
                            isSelfCol={densityCompactOptions.isSelfCol}
                            unmaskedColumns={densityCompactOptions.unmaskedColumns}
                        />
                    )}
            </Grid>
        </>
    );
};
